/* import __COLOCATED_TEMPLATE__ from './create-flow.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import { BITCOIN_TREASURY_ACCOUNT_TYPE, DEFAULT_BITCOIN_WITHHOLDING_BPS } from '@banking/ui/utils/constants';
import { inject as service } from '@ember/service';
import { Owner, OwnerType } from '@square/dashboard-protos/models/squareup/banking/common';
import { WithholdingConfig } from '@square/dashboard-protos/models/squareup/banking/withholding_config_model';
import { select } from '@banking/ui/services/investments-workflow';
import { createBtcWithholdingConfigRequestAction, getCurrentBitcoinPriceRequestAction, getMaxWithholdingRequestAction, setOnboardingScreenAction, setTwoFactorAuthEnabledAction, updateBtcWithholdingConfigRequestAction } from '@banking/ui/workflows/investments';
import fetchMultipassStatus from '@banking/api/utils/multipass-status';
import { INVEST_OPEN_ONBOARDING } from '@banking/ui/utils/invest-cdp-events';
import { scheduleOnce } from '@ember/runloop';
let InvestmentsCreateFlow = (_dec = select(state => state.currentOnboardingScreen), _dec2 = select(state => state.maxWithholdingBps), _dec3 = select(state => state.isLoading), _dec4 = select(state => state.isLoadingScreen), _dec5 = select(state => state.withholdingConfig), _dec6 = select(state => state.isTwoFactorEnabled), _dec7 = computed('features', 'isTwoFactorEnabled'), (_class = class InvestmentsCreateFlow extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "sentry", _descriptor2, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "investmentsWorkflow", _descriptor5, this);
    _initializerDefineProperty(this, "features", _descriptor6, this);
    _initializerDefineProperty(this, "dataApi", _descriptor7, this);
    _initializerDefineProperty(this, "page", _descriptor8, this);
    _initializerDefineProperty(this, "maxBps", _descriptor9, this);
    _initializerDefineProperty(this, "isLoading", _descriptor10, this);
    _initializerDefineProperty(this, "isLoadingScreen", _descriptor11, this);
    _initializerDefineProperty(this, "withholdingConfig", _descriptor12, this);
    _initializerDefineProperty(this, "isTwoFactorEnabled", _descriptor13, this);
    _defineProperty(this, "withholdingBps", DEFAULT_BITCOIN_WITHHOLDING_BPS);
    _defineProperty(this, "accountType", BITCOIN_TREASURY_ACCOUNT_TYPE);
    fetchMultipassStatus().then(response => {
      this.investmentsWorkflow.emit(setTwoFactorAuthEnabledAction(response.requiresTwoFactor));
    });
    this.dataApi.track(INVEST_OPEN_ONBOARDING, {
      token: this.capitalEngineContext.sessionContext.merchantToken
    });

    // This is to prevent the rendering error Ember was throwing in the local environment:
    // "You attempted to update `state` on `<InvestmentsWorkflow:ember217>`,
    // but it had already been used previously in the same computation"
    scheduleOnce('afterRender', this, this.afterRender);
  }
  afterRender() {
    const merchantOwner = Owner.create({
      type: OwnerType.MERCHANT,
      id: this.capitalEngineContext.sessionContext.merchantToken
    });
    this.investmentsWorkflow.emit(getMaxWithholdingRequestAction(merchantOwner));
    this.investmentsWorkflow.emit(getCurrentBitcoinPriceRequestAction(merchantOwner));
  }
  setOnboardingScreen(newPage) {
    this.investmentsWorkflow.emit(setOnboardingScreenAction(newPage, true));
  }
  get eligibilityScreenNext() {
    if (!this.isTwoFactorEnabled) {
      return 'phoneNumber';
    }
    if (this.features.isEnabled('squareinvest/cashtag_linking')) {
      return 'linking';
    }
    return 'withholding';
  }
  createWithholding() {
    const owner = Owner.create({
      type: OwnerType.MERCHANT,
      id: this.capitalEngineContext.sessionContext.merchantToken
    });
    const withholdingConfig = WithholdingConfig.create({
      ...this.withholdingConfig,
      withholdingBps: this.withholdingBps,
      enabled: true
    });

    // TODO(tianbi) clean up usages of CreateBtcWithholdingConfig https://jira.sqprod.co/browse/SQBTC-239
    if (this.features.isEnabled('squareinvest/cashtag_linking')) {
      this.investmentsWorkflow.emit(updateBtcWithholdingConfigRequestAction(owner, withholdingConfig, false));
    } else {
      this.investmentsWorkflow.emit(createBtcWithholdingConfigRequestAction(owner, withholdingConfig));
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "investmentsWorkflow", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "page", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "maxBps", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "isLoadingScreen", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "withholdingConfig", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "isTwoFactorEnabled", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "afterRender", [action], Object.getOwnPropertyDescriptor(_class.prototype, "afterRender"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setOnboardingScreen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setOnboardingScreen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "eligibilityScreenNext", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "eligibilityScreenNext"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createWithholding", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createWithholding"), _class.prototype)), _class));
export { InvestmentsCreateFlow as default };